import { IMyListGroup } from '@models/IMyListListing';
import { getCookie, setCookie } from '@utility/helpers/cookieUtils';

const cookieName = 'my-lists';

export const getMyListFromCookie = (): Array<IMyListGroup> => {
  const cookieString = getCookie(cookieName);
  if (!cookieString) return [];

  return JSON.parse(cookieString);
};

export const setMyListCookie = (
  list: Array<IMyListGroup>,
  hasCookieConsent: boolean,
) => {
  let expiration: Date | null = null;

  // Save cookies for one year if user consents, otherwise it will delete at the end of the session
  if (hasCookieConsent) {
    expiration = new Date();
    expiration.setFullYear(new Date().getFullYear() + 1);
  }

  // Update counter in Razor Nav
  const counterEl = document?.getElementById('favorites-counter');
  if (counterEl) {
    const allIds = getAllLikedIds(list);
    counterEl.innerHTML = allIds.length.toString();
  }

  setCookie(cookieName, list, expiration ?? undefined);
};

export const getAllLikedIds = (myList: Array<IMyListGroup>): string[] =>
  myList.flatMap((listItem) => listItem.items);

// Remove every instance of an id from all wishlists
export const removeItemById = (
  id: string,
  myList: Array<IMyListGroup>,
): Array<IMyListGroup> =>
  myList
    .map((listItem) => {
      const filteredItems =
        listItem.items?.filter((item) => item !== id) ?? listItem;
      return { ...listItem, items: filteredItems };
    })
    .filter((listItem) => listItem.items.length > 0);
